<template >
<template v-if="paths != null && paths[0] != null">
  <div class="objectFit squareImage aboutImage" v-if="isAboutImage">
    <img :src="paths[0]" :class="class" @error="setAltImg">
  </div>
  <img v-else :src="paths[0]" :class="class" @error="setAltImg">
</template>
</template>

<script>
export default {
  name: 'image-with-two-sources',
  // components: {
  //   'vue-highcharts': Vue3Highcharts
  // },
  props: ['paths', 'class', 'isAboutImage'],
  emits: ['update:modelValue', 'filter:modelValue'],
  setup (props) {
    const setAltImg = (event) => {
      if (event.target.src !== props.paths[1]) {
        event.target.src = props.paths[1];
      }
    }

    return {
      setAltImg
    }
  }

}
</script>
<style scoped>
  .aboutImage {
    width: 300px;
    height: 300px;
    margin: 0 auto;
}
</style>
